/**
 *
 * Error
 *
 */

import { memo } from 'react';
import { Helmet } from 'react-helmet-async';

import ErrorImage from 'assets/images/art-hero-404.png';

import { Wrapper, ContentWrapper } from './styles';

import packageJSON from '../../../../package.json';

interface Props {}

export const Error = memo((props: Props) => {
  /**
   * Return
   */
  return (
    <>
      <Helmet>
        <title>{`${packageJSON.appName} - 404`}</title>
        <meta name="description" content={`${packageJSON.appName} - 404`} />
      </Helmet>
      <Wrapper>
        <ContentWrapper>
          <img src={ErrorImage} alt={`${packageJSON.appName} 404`} />
          <div>
            <h1>Hmm, that's weird</h1>
            <p>This page seems to be missing.</p>
          </div>
        </ContentWrapper>
      </Wrapper>
    </>
  );
});

export default Error;
